import {
  createDeleteListFormData,
  createUpdateListFormData,
  listActionStandard,
} from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class PopupEditSection {
  public editSectionPopup: HTMLElement;

  public editButtons: NodeListOf<HTMLElement>;

  public actionButtons: NodeListOf<HTMLElement>;

  public formEditSection: HTMLFormElement;

  public sectionFilter: HTMLElement;

  public confirmPopup: HTMLElement;

  public editPopupWasOpen: boolean = false;

  public listId: string;

  public listTitle: string;

  public wishlistContent: any;

  constructor(wishlistContent: any) {
    this.wishlistContent = wishlistContent;
  }

  saveDetails(e: Event) {
    const target = e.currentTarget as HTMLElement;

    this.listId = target.dataset.listId as string;
    this.listTitle = target.dataset.listTitle as string;

    (this.formEditSection.querySelector('input[name="listId"]') as HTMLFormElement).value = this.listId;
    (this.formEditSection.querySelector('input[name="title"]') as HTMLFormElement).value = this.listTitle;

    this.editPopupWasOpen = true;
  }

  async handleActionButton(e: Event) {
    const target = e.currentTarget as HTMLElement;

    switch(target.dataset.action) {
      case 'delete':
        this.editSectionPopup.classList.remove('m-popup--is-active');
        this.confirmPopup.classList.add('m-popup--is-active');

        const confirmDeleteButton = this.confirmPopup.querySelector('.a-button:last-child') as HTMLElement;

        confirmDeleteButton.addEventListener('click', async (e: Event) => {
          e.preventDefault();

          try {
            await listActionStandard(createDeleteListFormData(this.listId));

            const parentListId = this.sectionFilter?.dataset.listId || '';
            const updateParentListFormData = createUpdateListFormData(parentListId);
            let parentListSections = [];

            parentListSections = this.wishlistContent
              .filter((list: any) => list.list_id == parentListId)[0].sections
              .map((section: any) => section.section_id)
              .filter((id: any) => id != this.listId);

            updateParentListFormData.append('fields[json_relation]', JSON.stringify({children: parentListSections}));

            await listActionStandard(updateParentListFormData);

            messageBoxSuccess({
              contentDe: 'Section wurde erfolgreich gelöscht.',
              contentEn: 'Successfully deleted section.',
            });

            setTimeout(() => {window.location.reload()}, 200);
          } catch (e) {
            console.error(e);

            messageBoxError({
              contentDe: 'Es ist ein Fehler aufgetreten. Section konnte nicht gelöscht werden',
              contentEn: 'An error appeared. Could not delete section.',
            });
          }
        });
        break;
      default:
    }
  }

  async handleSubmit(e: Event) {
    e.preventDefault();

    try {
      await listActionStandard(new FormData(this.formEditSection));

      messageBoxSuccess({
        contentDe: 'Section wurde erfolgreich gespeichert.',
        contentEn: 'Successfully saved section.',
      });

      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Section konnte nicht gespeichert werden.',
        contentEn: 'An error appeared. Could not save section.',
      });
    }
  }

  bindings() {
    if (this.editButtons) {
      this.editButtons.forEach((button) => {
        button.addEventListener('click', this.saveDetails.bind(this));
      });
    }

    if (this.actionButtons) {
      this.actionButtons.forEach((button) => {
        button.addEventListener('click', this.handleActionButton.bind(this));
      });
    }

    if (this.formEditSection) {
      this.formEditSection.addEventListener('submit', this.handleSubmit.bind(this));
    }

    if (this.confirmPopup) {
      this.confirmPopup.querySelector('.a-button:first-child')?.addEventListener('click', () => {
        this.confirmPopup.classList.remove('m-popup--is-active');

        if (this.editPopupWasOpen) {
          this.editSectionPopup.classList.add('m-popup--is-active');
        }
      });
    }
  }

  cache() {
    this.editSectionPopup = document.getElementById('wishlist-popup-edit-section') as HTMLElement;
    this.confirmPopup = document.querySelector('.m-wishlist-popup.m-confirm-popup') as HTMLElement;
    this.editButtons = document.querySelectorAll('.m-wishlist-section-headline__button-edit');
    this.actionButtons = this.editSectionPopup?.querySelectorAll('.a-wishlist-button');
    this.formEditSection = this.editSectionPopup?.querySelector('.js-form-rename') as HTMLFormElement;
    this.sectionFilter = document.querySelector('.m-wishlist-section-filter') as HTMLElement;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PopupEditSection;
